import styled from "styled-components/macro";
import { RegularText } from "../../../../../../components/Typography/Typography";
import { screenSize } from "../../../../../../theme";
import type { OptionType } from "../../../../../../types/types";
import {
  CSVIcon,
  DocumentIcon,
  DownloadIcon,
} from "../../../../../../components/Icons/Icons";

export type UploadStages = "table" | "download" | "upload";

export type UploadState = {
  uploadStage: UploadStages;
  selectedTemplate?: OptionType<string>;
  showConfirmTemplateSelectionButton: boolean;
  collectionFileNames: Record<string, string>;
  selected_products?: string[] | "all";
  export_id?: string;
};

export type UploadAction = {
  type:
    | "select_template"
    | "comfirm_template"
    | "set_export_id"
    | "set_selected_products"
    | "continue_from_download"
    | "discard_template"
    | "move_back"
    | "complete";
  payload: UploadState;
};

export type AsyncTableType = {
  id: string;
  externalId: string;
  name: string;
  chemical_name: string;
};

export const DownloadTemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  @media ${screenSize.medium} {
    width: 100%;
  }
`;

export const RegularTextBlock = styled(RegularText)`
  display: block;
`;

export const TemplateButtonContainer = styled.div`
  display: flex;
  gap: 16px;
`;

const DocumentDownloadCard = styled.a`
  text-decoration: none;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.primaryBorder};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 11px 15px;
  width: fit-content;
  color: ${({ theme }) => theme.primaryTextColor};
  :hover,
  :focus {
    border: 2px solid ${({ theme }) => theme.primaryBorder};
  }
`;

export const convertArrayBufferToZipUrl = (data: Blob) =>
  URL.createObjectURL(data);

export const DocumentDownloadContainer = ({
  link,
  documentName,
  type,
}: {
  link: string;
  documentName: string;
  type: "application/zip" | "text/csv";
}) => {
  const updatedDocumentName = (() => {
    const ext = documentName.split(".").pop();
    const possible_extensions = ["csv", "zip"];
    return possible_extensions.some((possible_ext) => possible_ext === ext)
      ? documentName
      : `${documentName}.${type.includes("csv") ? "csv" : "zip"}`;
  })();
  return (
    <DocumentDownloadCard
      href={link}
      download={updatedDocumentName}
      target="_blank"
      rel="noopener noreferrer"
      type={type}
    >
      {type === "application/zip" ? (
        <DocumentIcon width={24} height={24} />
      ) : (
        <CSVIcon width={24} height={24} />
      )}
      {updatedDocumentName}
      <DownloadIcon width={16} height={16} />
    </DocumentDownloadCard>
  );
};
